import { connect } from 'react-redux'
import { ProductSheetComponent } from './ProductSheetComponent'
import type { MenuElement, MenuSection } from 'shared/store/product'
import {
    fetchProductPageData,
    handleElementClick,
    handleTabClick,
    resetProductPageData
} from 'shared/store/product'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'

import type { ECommerceMetadata, EventMetadata } from 'shared/store/metadata'
import { eCommerceMetadata, eventMetadata } from 'shared/store/metadata'

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchProductPageData: (route: string, edito: boolean) =>
        d(fetchProductPageData(route, edito)),
    resetProductPageData: () => d(resetProductPageData()),
    handleTabClick: (section: MenuSection) => d(handleTabClick(section)),
    handleElementClick: (element: MenuElement, section: MenuSection) =>
        d(handleElementClick(element, section)),
    sendEventMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    sendECommerceMeta: (meta: ECommerceMetadata) => d(eCommerceMetadata(meta))
})

const mapStateToProps = (state: RootState) => state.productPageState

const ProductSheet = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductSheetComponent)

export { ProductSheet }
